import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { ProjectsModule } from '../../projects/projects.module';
import { transactionRoutes } from './transaction.routes';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TransactionService } from './services/transaction.service';

import { TransactionContentComponent } from './components/transaction-content/transaction-content.component';

import { TransactionImportComponent } from './components/transaction-import/transaction-import.component';
import { TransactionOverviewComponent } from './components/transaction-overview/transaction-overview.component';
import { SearchTransactionByCountryNamePipe } from './pipes/search-transaction-by-country-name.pipe';
import { transactionReducer } from './store/reducers/transaction.reducer';
import { TransactionCountrySelectorComponent } from './components/transaction-country-selector/transaction-country-selector.component';
import { TransactionImportToolbarComponent } from './components/transaction-import/transaction-import-toolbar/transaction-import-toolbar.component';
import { TransactionSettingsComponent } from './components/transaction-settings/transaction-settings.component';
import { TransactionToolbarComponent } from './components/transaction-toolbar/transaction-toolbar.component';
import { TransactionEffects } from './store/effects/transaction.effects';
import { TransactionChartImportExportEffect } from './store/effects/transaction-import-export.effects';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  imports     : [
    CommonModule,
    RouterModule.forChild(transactionRoutes),
    StoreModule.forFeature('cr-transaction', transactionReducer),
    EffectsModule.forFeature([TransactionEffects, TransactionChartImportExportEffect]),
    SharedModule,
    MatTooltipModule,
    ProjectsModule
  ],
  providers   : [TransactionService],
  declarations: [
    TransactionContentComponent,
    TransactionCountrySelectorComponent,
    TransactionImportToolbarComponent,
    TransactionImportComponent,
    TransactionOverviewComponent,
    TransactionSettingsComponent,
    TransactionToolbarComponent,
    SearchTransactionByCountryNamePipe],
  exports     : [TransactionSettingsComponent]
})
export class TransactionModule {
}
